module.exports = __webpack_public_path__ + "img/withdraw4.3f6e339e.jpg";